(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // Scoped custom element: also initializes cards added by filtering or the theme editor.
if (!customElements.get('facetra-card-video')) {
  class FacetraCardVideo extends HTMLElement {
    static get observedAttributes() { return ['data-video-id', 'data-playback']; }

    attributeChangedCallback(name, previous, next) {
      if (previous === next || !this.abortController) return;
      this.disconnectedCallback();
      this.connectedCallback();
    }

    connectedCallback() {
      // A connected callback can run before this element's children are parsed.
      this.connectTimer = setTimeout(() => this.connect(), 0);
    }

    connect() {
      if (!this.isConnected || this.abortController) return;
      this.video = this.querySelector('video');
      this.gallery = this.closest('.card-gallery');
      if (!this.video || !this.gallery) return;
      this.card = this.closest('product-card, product-card-link') || this.gallery;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const listen = (target, name, handler, capture = false) =>
        target.addEventListener(name, handler, { signal, capture });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.hoverDevice = matchMedia('(hover: hover) and (pointer: fine)');
      this.visible = false;
      this.hovered = this.gallery.matches(':hover');
      this.failed = false;
      this.manual = false;
      this.swatchPreview = false;
      this.requestId = (this.requestId || 0) + 1;
      this.pending = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.loop = true;
      this.nativeHover = ['on:pointerenter', 'on:pointerleave'].map((name) => [name, this.gallery.getAttribute(name)]);
      this.hoverSuppressed = false;

      listen(this.video, 'playing', () => {
        this.pending = false;
        if (!this.shouldPlay()) return this.stop();
        this.suppressHover();
        this.setAttribute('data-playing', '');
      });
      // Keep the current frame visible during buffering; the browser resumes itself.
      listen(this.video, 'pause', () => this.removeAttribute('data-playing'));
      listen(this.video, 'error', () => this.fail());
      listen(document, 'visibilitychange', () => this.update());
      listen(this.motion, 'change', () => this.update());
      listen(this.hoverDevice, 'change', () => this.update());
      listen(this.gallery, 'pointerenter', () => { this.hovered = true; this.update(); });
      listen(this.gallery, 'pointerleave', () => { this.hovered = false; this.update(); });

      // Swatch/slide interactions take priority over the product-level video.
      // Do not cancel the events: the theme still handles its normal images and links.
      const swatchSelector = 'swatches-variant-picker-component, variant-picker, input[data-variant-id], input[type="radio"], select';
      listen(this.card, 'change', (event) => {
        if (event.target instanceof Element && event.target.closest(swatchSelector)) this.useImages();
      }, true);
      listen(this.card, 'pointerdown', (event) => {
        if (!(event.target instanceof Element)) return;
        if (this.gallery.contains(event.target) || event.target.closest(swatchSelector)) this.useImages();
      }, true);
      listen(this.card, 'pointerover', (event) => {
        if (event.target instanceof Element && event.target.closest(swatchSelector)) {
          this.swatchPreview = true;
          this.update();
        }
      }, true);
      listen(this.card, 'pointerleave', () => {
        this.swatchPreview = false;
        this.update();
      });
      listen(this.card, 'focusin', (event) => {
        if (event.target instanceof Element && event.target.closest(swatchSelector)) this.useImages();
      }, true);
      listen(this.gallery, 'keydown', (event) => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', ' '].includes(event.key)) this.useImages();
      }, true);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          this.update();
        }, { threshold: [0, 0.5] });
        this.observer.observe(this);
      }
      // Older browsers without IntersectionObserver keep the standard images.
    }

    eligible() {
      return this.isConnected && this.visible && !document.hidden && !this.motion.matches &&
        !this.failed && !this.manual && !this.swatchPreview &&
        !this.closest('[product-grid-view="zoom-out"]');
    }

    shouldPlay() {
      const hoverAllowed = this.dataset.playback !== 'hover' || !this.hoverDevice.matches || this.hovered;
      return this.eligible() && hoverAllowed;
    }

    update() {
      if (!this.shouldPlay()) {
        this.stop();
        // Reserve mouse hover for video before pointerenter reaches theme handlers.
        if (this.eligible() && this.dataset.playback === 'hover') this.suppressHover();
        return;
      }
      if (this.pending || (!this.video.paused && this.hasAttribute('data-playing'))) return;
      this.pending = true;
      const requestId = ++this.requestId;
      this.suppressHover();
      try {
        const attempt = this.video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => {
            if (requestId === this.requestId && this.shouldPlay()) this.fail();
          });
        }
      } catch (_) {
        this.fail();
      }
    }


    suppressHover() {
      if (this.hoverSuppressed) return;
      for (const [name] of this.nativeHover) this.gallery.removeAttribute(name);
      this.hoverSuppressed = true;
    }

    restoreHover() {
      if (!this.hoverSuppressed) return;
      for (const [name, value] of this.nativeHover) {
        if (value !== null && !this.gallery.hasAttribute(name)) this.gallery.setAttribute(name, value);
      }
      this.hoverSuppressed = false;
    }

    stop() {
      this.requestId++;
      this.pending = false;
      this.removeAttribute('data-playing');
      if (this.video && !this.video.paused) this.video.pause();
      this.restoreHover();
    }

    fail() {
      this.failed = true;
      this.stop();
    }

    useImages() {
      this.manual = true;
      this.stop();
    }

    disconnectedCallback() {
      clearTimeout(this.connectTimer);
      if (!this.abortController) return;
      this.stop();
      this.abortController.abort();
      this.abortController = null;
      this.observer?.disconnect();
    }
  }

  customElements.define('facetra-card-video', FacetraCardVideo);
}
  } catch(e) { console.error(e); }
})();

})();
